<template>
    <section class="odocs-spaced">
        <o-dropdown mobile-modal desktop-modal aria-label="modal example">
            <template #trigger>
                <o-button variant="primary" label="Click to open modal!" />
            </template>

            <o-dropdown-item label="Action" />
            <o-dropdown-item label="Another action" />
            <o-dropdown-item label="Something else" />
        </o-dropdown>
    </section>
</template>
